import { IconV1 } from 'common/icon/iconV1.js';
import { LinkFactoryReactRouter } from 'common/link/link-react-router.js';
import { PageLoader } from 'components/page-loader.js';
import { normaliseDynamicComponentName } from 'layout/registry-naming.js';
import { memo, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'redux-state/configure-store.js';
import { REDUX_LAYOUT_CLEAR_OVERLAY } from 'redux-state/layout/reducer.js';
import { OverlayContent } from './overlay-content.js';

export const OverlayLayout = memo(() => {
  const appDispatch = useAppDispatch();
  const layout = useAppSelector((s) => s.LAYOUT.overlay?.layout);
  const mainUrl = useAppSelector((s) => s.LAYOUT.screen.url);
  const navigate = useNavigate();

  const closeOverlay = useCallback(() => {
    appDispatch(REDUX_LAYOUT_CLEAR_OVERLAY());
    if (mainUrl) {
      navigate(mainUrl);
    }
  }, [mainUrl, navigate, appDispatch]);

  if (layout) {
    const { title, subtitle } = layout;
    const moduleName = normaliseDynamicComponentName(layout.name);

    return (
      <div data-comp="overlay-comp" className="Overlay">
        <div className="Overlay-group-header">
          <div className="Overlay-group-header-bar">
            <button className="Overlay-group-header-bar-close" onClick={closeOverlay}>
              <IconV1 iconClass="svg--fill-inherit svg--1em" icon="exit" />
            </button>
            <h2 className="h1 u-mT-0 u-mB-0">{title}</h2>
            {subtitle && (
              <p className="u-mT-xs u-mB-0">
                <LinkFactoryReactRouter
                  className="small u-linkClean u-textWhite svg--fill-hover"
                  href={subtitle.action}
                >
                  {subtitle.label} <IconV1 icon="chevron-right" iconClass="svg--1em svg-fill-white" />
                </LinkFactoryReactRouter>
              </p>
            )}
          </div>
        </div>
        <div className="Overlay-group-body">
          <PageLoader>
            <div className="Overlay-content">
              <div className={`Layout Layout--${moduleName}`}>
                <OverlayContent layout={layout} />
              </div>
            </div>
          </PageLoader>
        </div>
      </div>
    );
  }
  return null;
});
